import { Component, Input } from '@angular/core';

import { SnListBaseComponent } from '@lib/core';

import { SnChannel } from '../../models';

@Component({
  selector: 'sn-channel-list',
  templateUrl: './channel-list.component.html',
})
export class SnChannelListComponent extends SnListBaseComponent<SnChannel> {
  @Input()
  public activatedItem: SnChannel;

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnChannel): any {
    return item.sid;
  }
}
